<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <znhyheader></znhyheader>
    </div>
    <div class=" row body-width divcss5">
      <router-view />
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import znhyheader from "@/components/contentcoms/prodecutcontentcoms/znhyxlcp/znhyheader";


  export default {
    name: "productznhy",
    components: {
      productdetailbanner,
      znhyheader,
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/productznhy.vue